import { atom } from "@reatom/framework";

export const MAX_FILL_PRODUCTS_COUNT = 10_000;

export const fillCountAtom = atom<number>(
  MAX_FILL_PRODUCTS_COUNT,
  "fillCountAtom",
);
